import { useCallback } from 'react';

import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { useReportError } from '@/hooks/useReportError';

import { Operations } from '../graphql/FamilyTree.generated';
import { useUpdateFamilyTreeSettingsMutation } from '../graphql/FamilyTreeMutations.generated';
import { FamilyTreeEffectFn, SaveVisualizationConfigEffect } from '../types';

export function useSaveVisualizationConfigEffect(): FamilyTreeEffectFn<SaveVisualizationConfigEffect> {
  const { reportError } = useReportError();
  const { showFeedback } = useFeedback();

  const [updateSettings] = useUpdateFamilyTreeSettingsMutation({
    onError: (error) => {
      showFeedback('Unable to save family tree settings. Please try again.');
      reportError('Error saving family tree settings', error);
    },
  });

  return useCallback<FamilyTreeEffectFn<SaveVisualizationConfigEffect>>(
    (_state, effect, _dispatch) => {
      // Always refetch the family tree to update connections
      const refetchFamilyTree = true;

      updateSettings({
        refetchQueries: refetchFamilyTree
          ? [Operations.Query.GetHouseholdFamilyTree]
          : undefined,
        variables: {
          householdId: effect.householdId,
          settings: {
            showAge: effect.config.showAge,
            showHiddenIndividuals: effect.config.showHiddenIndividuals,
            showNotes: effect.config.showNotes,
            showStateOfResidence: effect.config.showStateOfResidence,
          },
        },
      });
    },
    [updateSettings]
  );
}
